import React, { useEffect, useState } from "react";
import { useReveal } from "../hooks/useReveal";

export function Counter({ to, suffix = "", duration = 1600 }) {
  const [ref, visible] = useReveal(0.6);
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!visible) return;
    let start = null;
    let frame;
    function step(ts) {
      if (!start) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      setVal(Math.floor(progress * to));
      if (progress < 1) frame = requestAnimationFrame(step);
      else setVal(to);
    }
    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [visible, to, duration]);
  return (
    <span ref={ref}>
      {val}
      {suffix}
    </span>
  );
}

export default Counter;
